import { memo } from "react";
// component

import { Box, Button } from "@mui/material";
import LogoImage from "assets/icons/logo.svg";
import LogoBlack from "assets/icons/logo-black.svg";
import LogoWhite from "assets/icons/logo-white.svg";
import { Link } from "react-router-dom";

// ----------------------------------------------------------------------

function Logo({ white = false, black = false, size, sx }) {
  return (
    <Link to="/">
      <Box
        sx={{
          lineHeight: 0,
          cursor: "pointer",
          ...sx,
        }}
      >
        <Box
          sx={{
            width: size || 200,
            height: 0,
            paddingBottom: "21%",
            background: `url(${
              white ? LogoWhite : black ? LogoBlack : LogoImage
            }) center/contain no-repeat`,
          }}
          origin
        />
      </Box>
    </Link>
  );
}

export default memo(Logo);
